import { type BaseAddress } from '~/types/Address';

/**
 * This function is used to get the locale of the user's browser.
 *
 * @remarks
 * **Avoid** using this function to get the locale when intend to use it in *Intl* namespace methods as they are not guaranteed to support all browser locales.
 * Instead, use the **i18n.language** property from 'react-i18next'.
 */
export const getLocale = (): string =>
  navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;

export const localeCountryCode = () => {
  const locale = getLocale().toUpperCase(); // This could be either 2 or 5 characters.
  return locale.substring(locale.length - 2); // We need the last 2 characters either way.
};

export const guessUsersCountry = (userAddress: Maybe<BaseAddress>): string => {
  if (userAddress?.country?.iso2) return userAddress.country.iso2;
  else return localeCountryCode();
};
